import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { init } from './couponHistorySlice';
import CouponComponentMain from "app/Components/Block/CouponComponentBlock/CouponComponentMain";
import CollapseButton from "app/utilities/CollapseButton/CollapseButton";
import {dwhCouponHistoryPageDisplayed} from "app/Components/Block/CouponHistory/Reports/dwhReports";
import {isMobile} from "react-device-detect";
import backArrowBlack from './images/back-arrow-black.svg';
import arrowUpIcon from './images/arrow-up.svg';
const CouponHistory = ({ contentData, init, couponHistory, loginData }) => {
  const [expiredCouponsCollapseIsOpen, setExpiredCouponsCollapseIsOpen] = useState(false);
  const [usedCouponsCollapseIsOpen, setUsedCouponsCollapseIsOpen] = useState(false);
  const { title: { value: title } } = contentData;
  const { coupons, isLoading } = couponHistory;
  useEffect(() => {
    dwhReport();
    init();
  }, [init, loginData]);

  const dwhReport = () => {
    const reportParams = {
      contact: Boolean(loginData?.userDetails?.IsContactPerson || loginData?.userDetails?.IsPrimaryContact) ? 'איש קשר' : 'מנוי',
      loginType: loginData?.isOtpAuthenticated ? 'לקוח OTP' :
        loginData?.isFullAuthenticated ? 'לקוח בזיהוי מלא' :
          loginData?.isOtpExtendedAuthenticated ? 'לקוח OTP מורחב' : 'Unknown',
      sourceUrl: window.location.href,
      customerName: `${loginData?.userDetails?.firstName || ''} ${loginData?.userDetails?.lastName || ''}`.trim(),
      idNumber: loginData?.userDetails?.IDNumber,
      subscriber: loginData?.userDetails?.contactNumber,
    };

    dwhCouponHistoryPageDisplayed(reportParams);
  }

  const isCouponValid = (date) => {
    const [day, month, year] = date.split('.').map(Number);
    const expiryDate = new Date(year < 100 ? year + 2000 : year, month - 1, day);
    return expiryDate >= new Date().setHours(0, 0, 0, 0);
  };

  const validCoupons = useMemo(() => {
    return coupons?.filter(coupon => isCouponValid(coupon.couponExpiryDate) && !coupon.isUsed) || [];
  }, [coupons]);

  const expiredCoupons = useMemo(() => {
    return coupons?.filter(coupon => !isCouponValid(coupon.couponExpiryDate) && !coupon.isUsed) || [];
  }, [coupons]);

  const usedCoupons = useMemo(() => {
    return coupons?.filter(coupon => coupon.isUsed) || [];
  }, [coupons]);

  const couponList = (couponsToShow) => (
    <div className={'coupons'}>
      {couponsToShow?.map((coupon, index) => (
        <CouponComponentMain
          key={index}
          coupon={coupon}
          couponNum={coupon.couponNumber}
          clientName={coupon.clientName}
          couponExpiryDate={coupon.couponExpiryDate}
          clientPhone={coupon.clientPhone}
        />
      ))}
    </div>
  );

  return (
    <div className={'coupon-history-container'}>
      <div className={'content-container'}>
        <div className={'title-container'}>
          {isMobile && <div className='back-arrow' onClick={() => window.history.back()} />}
          <span className={'title'}>{title}</span>
        </div>
        {!isLoading && (
          <>
            {coupons?.length === 0 || expiredCoupons?.length === coupons?.length ? (
              <div className={'empty'}>
                <Image src={require('./images/coupon.svg')} alt="empty" className={'empty-image'} />
                <span className={'empty-message'}>כרגע לא קיימים קופונים</span>
              </div>
            ) : (
              <div className={'coupon-list'}>
                <div className={'list-title-container'}>
                  <span className={'list-title'}>הקופונים שלי ({coupons?.length - expiredCoupons?.length})</span>
                </div>
                {couponList(validCoupons)}
              </div>
            )}
            {coupons?.length > 0 && usedCoupons?.length > 0 && (
              <div className={'coupon-list'}>
                <CollapseButton
                  cardTitle={`קופונים שמומשו (${usedCoupons?.length})`}
                  setIsOpen={() => setUsedCouponsCollapseIsOpen(!usedCouponsCollapseIsOpen)}
                  isOpen={usedCouponsCollapseIsOpen}
                  icon={arrowUpIcon}
                />
                {usedCouponsCollapseIsOpen && couponList(usedCoupons)}
              </div>
            )}
            {coupons?.length > 0 && expiredCoupons?.length > 0 && (
              <div className={'coupon-list'}>
                <div className={'list-title-container list-title'}>
                  <CollapseButton
                    cardTitle={`קופונים שאינם בתוקף (${expiredCoupons?.length})`}
                    setIsOpen={() => setExpiredCouponsCollapseIsOpen(!expiredCouponsCollapseIsOpen)}
                    isOpen={expiredCouponsCollapseIsOpen}
                    icon={arrowUpIcon}
                  />
                </div>
                {expiredCouponsCollapseIsOpen && couponList(expiredCoupons)}
              </div>
            )}

          </>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  couponHistory: state.couponHistory,
  loginData: state.authentication?.loginData,
});

const mapDispatchToProps = {
  init
};

export default connect(mapStateToProps, mapDispatchToProps)(CouponHistory);
